<mwe-modal [model]="popupModel()">
  @if (loadedData?.routerName) {
    <mwe-mvno-info-text-popup [loadedData]="loadedData" (onCloseClick)="closePopup()" />
  } @else {
    <p [innerHTML]="loadedData?.description | translate" class="mb-0" data-test="info-text-popup-text"></p>
    @if (loadedData?.link?.target && loadedData?.link?.name) {
      <a
        [href]="loadedData?.link.target"
        class="clickable-brand d-inline-block mt-4 mb-2"
        data-test="info-text-popup-link"
        target="_blank"
        [attr.aria-label]="loadedData?.link.accessibilityText ? loadedData?.link.accessibilityText : loadedData?.link.name"
      >
        {{ loadedData?.link.name | translate }}
      </a>
    }
  }
</mwe-modal>
